import "../../assets/styles/product-view.css";
import React from "react";
import img_CheckVATID from "../../assets/images/CheckVAT ID.jpg";
import img_ClearCustoms from "../../assets/images/ClearCustoms.jpg";
import img_ClearVAT from "../../assets/images/ClearVAT.jpg";
import img_SPOT from "../../assets/images/SPOT.jpg";
import img_VATRules from "../../assets/images/VATRules.jpg";
import img_CustomsRules from "../../assets/images/CustomsRules.jpeg";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";

const MatchingProducts = () => {
  const navigate = useNavigate();
  const navigateTo = (e, route) => {
    e.preventDefault();
    navigate(route);
  };
  const { language } = useParams();

  return (
    <div
      data-content-type="html"
      data-appearance="default"
      data-element="main"
      data-pb-style="QJS8FTY"
      data-decoded="true"
    >
      <div className="product-features">
        <div className="features-content">
          <h3 className="title">
            <FormattedMessage id="Products that match your selection" />
          </h3>
          <p>
            <FormattedMessage id="VAT automation" />
          </p>
        </div>

        <div
          className="features-list"
          style={{
            display: "flex",
            width: "80%",
            margin: "auto",
            justifyContent: "normal",
          }}
        >
          <div className="col-2">
            <a
              href="#"
              onClick={(e) => {
                navigateTo(e, `/store/${language}/product/clearvat`);
              }}
            >
              <img alt="ClearVAT" src={img_ClearVAT} className="product-img" />
            </a>
          </div>
          <div className="col-2">
            <a
              href="#"
              onClick={(e) => {
                navigateTo(e, `/store/${language}/product/clearcustoms`);
              }}
            >
              <img
                alt="ClearCustoms"
                src={img_ClearCustoms}
                className="product-img"
              />
            </a>
          </div>
          <div className="col-2">
            <a
              href="#"
              onClick={(e) => {
                navigateTo(e, `/store/${language}/product/vatrules`);
              }}
            >
              <img alt="VATRules" src={img_VATRules} className="product-img" />
            </a>
          </div>
          <div className="col-2">
            <a
              href="#"
              onClick={(e) => {
                navigateTo(e, `/store/${language}/product/checkvat-id`);
              }}
            >
              <img
                alt="CheckVAT ID"
                src={img_CheckVATID}
                className="product-img"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MatchingProducts;
